{
  "home": {
    "tagline": "Более 1 миллиона владельцев собак тренируются с Hundeo",
    "subline": "Рекомендовано профессиональными кинологами",
    "appStorePrefix": "Загрузите в",
    "playStorePrefix": "Доступно в",
    "qrHint": "Откройте приложение на телефоне",
    "qrCaption": "Отсканируйте код камерой",
    "socialProof": "5 000+ пятизвёздочных отзывов",
    "imprint": "Imprint",
    "privacy": "Конфиденциальность",
    "language": "Язык",
    "openWebsite": "На сайт",
    "openInApp": "Открыть в приложении Hundeo",
    "openInAppHint": "Вы перейдёте в приложение",
    "openInAppButton": "Открыть",
    "promoRedirectTitle": "Открываем ваше предложение …",
    "promoRedirectButton": "Перейти к предложению"
  }
}
